export default function ppcPhoneSwap (document, moduleHTML, appEventEmitter) {
  const phoneRegex = /(1?(-?\d{3})-?)?(\d{3})(-?([a-zA-Z]{4}|\d{4}))/g
  const telAnchor = moduleHTML
  const params = new URLSearchParams(window.location.search)
  const phoneQueryValue = params.get('phone')

  if (phoneQueryValue) {
    telAnchor.href = `tel:${phoneQueryValue}`
    telAnchor.innerHTML = telAnchor.innerHTML.replace(phoneRegex, formatPhone(phoneQueryValue))
  }

  function formatPhone (phoneNumber) {
    if (phoneNumber.length === 10) {
      return [
        phoneNumber.substring(0, 3),
        phoneNumber.substring(3, 6),
        phoneNumber.substring(6, 10)
      ].join('-')
    } else if (phoneNumber.length === 7) {
      return [
        phoneNumber.substring(0, 3),
        phoneNumber.substring(3, 8)
      ].join('-')
    } else {
      return phoneNumber
    }
  }
}
